import { render, staticRenderFns } from "./AccettazioneSsnEditViewComponent.vue?vue&type=template&id=c05db17e&scoped=true"
import script from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnEditViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnEditViewComponent.vue?vue&type=style&index=0&id=c05db17e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05db17e",
  null
  
)

export default component.exports